import React, { useState, useEffect, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import 'ag-grid-enterprise';
import { withStyles } from '@material-ui/core/styles';
import { Button, CircularProgress, Switch } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { DEFAULT_API_CONFIG } from '../../services/apiConfig';
import CustomTooltip from './CustomComponents/CustomTooltip';

import { getGridExcelExport } from '../../services';
import { orderLineStatusLookupCodes } from '../../enums';
import { format } from 'date-fns';

const AG_GRID_COLUMN_SIZE_AND_PIN_STORAGE_KEY = 'AG_GRID_COLUMN_SIZE_AND_PIN';
const AG_GRID_COLUMN_STATE_STORAGE_KEY = 'AG_GRID_COLUMN_STATE';
const FILTERS_STORAGE_KEY = 'AG_GRID_FILTERS';
const SORT_STORAGE_KEY = 'AG_SORT_FILTERS';

// constants for setting consistent widths in column definitions
export const gridConstants = {
  BOOLEAN_FIELD_WIDTH: 50,
  ADDRESS_FIELD_WIDTH: 300,
  DATE_FIELD_WIDTH: 175,
};

const styles = theme => ({
  createButton: {
    padding: 10,
    margin: 10,
    borderRadius: 4,
    border: '0.5px solid black',
    backgroundColor: 'rgba(0,0,0,0.1)',

    '&:hover': {
      cursor: 'pointer',
      boxShadow: '0 0 10px rgba(0,0,0,0.4)',
    },
  },

  mainContainer: {
    minHeight: 400,
  },
});

class MyCustomToolbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      totalRecords: null,
      filteredRecords: null,
      renderedRecords: null,
    };
  }

  updateRecords = (total, rendered, filtered) => {
    this.setState({
      totalRecords: total,
      renderedRecords: rendered,
      filteredRecords: filtered,
    });
  };

  render() {
    
    const { filteredRecords, totalRecords, renderedRecords } = this.state;
    return (
      <div
        style={{
          height: 50,
          width: '100%',
          flex: 1,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {/* <div>
          {filteredRecords !== totalRecords && (
            <span>Filtered: {filteredRecords}</span>
          )}
        </div> */}
        <div>Rendered Records: {renderedRecords}</div>
        <div style={{ marginLeft: 25 }}>Total Records: {totalRecords}</div>
      </div>
    );
  }
}

class StatusPanelLoading extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  setIsLoading = isLoading => {
    this.setState({
      isLoading,
    });
  };

  render() {
    return (
      <div
        style={{
          height: 50,
          width: '100%',
          flex: 1,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {this.state.isLoading && <CircularProgress size={24} className="dark-blue-text" />}
      </div>
    );
  }
}

// functions to use for select inputs
export const extractValues = mapping => {
  return Object.keys(mapping);
};
export const lookupValue = (mapping, key) => {
  return mapping[key];
};
export const lookupKey = (mapping, name) => {
  for (let key in mapping) {
    if (mapping.hasOwnProperty(key)) {
      if (name === mapping[key]) {
        return key;
      }
    }
  }
};

// filters to use with columns
export const filters = {
  date: 'agDateColumnFilter',
  number: 'agNumberColumnFilter',
  text: 'agTextColumnFilter',
  set: 'agSetColumnFilter',
};

// filter functions for consistent filtering
export const filterParams = {
  date: {
    comparator: function(filterLocalDateAtMidnight, cellValue) {
      var cellDate = new Date(cellValue);
      const midnightTime = filterLocalDateAtMidnight.getTime();
      const cellDateTime = cellDate.getTime();

      if (midnightTime === cellDateTime) {
        return 0;
      }
      if (cellDateTime < midnightTime) {
        return -1;
      }
      if (cellDateTime > midnightTime) {
        return 1;
      }
    },
  },
  // set: {
  //   values: params => {
  //     console.log(params)

  //     return params.success(['hello'])
  //   }
  // }
};

export const AgGrid = withStyles(styles)(props => {
  // deconstruct the props needed
  const {
    classes,
    // history,
    gridData,
    columnDefs,
    gridOptions,
    gridTheme,
    handleCellClick,
    handleCreateClick,
    onCellClicked,
    showCreateButton,
    onSave,
    defaultColDef,
    sideBar,
    statusBar,
    floatingFilter,
    rowClassRules,
    redirectOnClick,
    editOnClick,
    suppressDragLeaveHidesColumns,
    extraGridProps,
    tableHeader,
    openBulkEditDialog,
    openBulkReleaseDialog,
    onGridReady,
    useDatasource,
    datasourceUrl,
    gridName,
    defaultFilters,
    allowServerExport,
    showLocalGridExport,
    headerContent,
    exportParams,
  } = props;

  /**
   * CONSTANTS FOR FILTERING AND CELL RENDERING
   */
  
  const cellRenderers = {
    dateUTC: (params, callerIsExport) => {
      let d = null;

      if (callerIsExport) {
        const { data, field } = params;
        d = data[field];
      } else {
        d = params.value;
      }

      if (d) {
        // debugger
        const date = new Date(d);
        return `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
      }
      return '-';
    },
    date: (params, callerIsExport) => {
      let d = null;

      if (callerIsExport) {
        const { data, field } = params;
        d = data[field];
      } else {
        d = params.value;
      }

      if (d) {
        // debugger
        const date = new Date(d);
        return format(date, 'M/d/yyyy');
      }
      return '-';
    },
    time: (params, callerIsExport) => {
      let d = null;

      if (callerIsExport) {
        const { data, field } = params;
        d = data[field];
      } else {
        d = params.value;
      }

      if (d) {
        // debugger
        const date = new Date(d);
        return format(date, 'hh:mm a');
      }
      return '-';
    },
    datetime: (params, callerIsExport) => {
      const { convertToLocalTime } = params;

      let d = null;

      if (callerIsExport) {
        const { data, field } = params;
        d = data[field];
      } else {
        d = params.value;
      }

      if (d) {
        if (convertToLocalTime && !d.includes('Z')) {
          d += 'Z';
        }

        const date = new Date(d);
        return format(date, 'M/d/yyyy hh:mm a');
      }
      return '-';
    },

    select: (params, callerIsExport) => {
      const { value } = params;
      return value;
    },
  };

  const defaultOpts = {
    rowModelType: useDatasource ? 'infinite' : '',
    datasource: null,

    frameworkComponents: {
      myCustomToolbar: MyCustomToolbar,
      StatusPanelLoading: StatusPanelLoading,
    },

    components: {
      customTooltip: CustomTooltip,
    },

    tooltipShowDelay: 0,
    tooltipMouseTrack: true,
  };

  // create default values (these values will be used with Object.assign() to add to any values passed in)
  const defaultColumnDefinition = {
    editable: false, // manually assign a column as editable to protect data
    sortable: true,
    filter: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    tooltipComponent: 'customTooltip',
  };
  const defaultSideBar = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
      },
    ],
    defaultToolPanel: '',
  };
  const defaultRowClassRules = {
    'ag-grid-row-edited': params => params.data && params.data.edited,
  };

  const statusPanels = [
    {
      statusPanel: 'StatusPanelLoading',
      key: 'statusPanelLoadingKey',
      serverSide: true,
      clientSide: true,
      align: 'left',
    },
    {
      statusPanel: 'myCustomToolbar',
      key: 'statusToolbarKey',
      serverSide: true,
      // clientSide: true,
      align: 'right',
    },
  ];
  const statusPanelsClientSide = [];
  const statusPanelsServerSide = statusPanels.filter(sp => sp.serverSide);
  const defaultStatusBar = {
    statusPanels: useDatasource ? statusPanelsServerSide : statusPanelsClientSide,
    // [
    // {
    //   statusPanel: "agTotalRowCountComponent",
    //   align: "left"
    // },
    // { statusPanel: "agFilteredRowCountComponent" },
    // { statusPanel: "agSelectedRowCountComponent" },
    // { statusPanel: "agAggregationComponent" },

    // ]
  };

  // instantiate all of the private variables
  const _gridTheme = gridTheme,
    // _gridOptions = Object.assign({}, defaultOpts, gridOptions),
    _defaultColDef = Object.assign({}, defaultColumnDefinition, defaultColDef),
    _floatingFilter = floatingFilter,
    _sideBar = !sideBar
      ? defaultSideBar
      : typeof sideBar === 'object'
      ? Object.assign({}, defaultSideBar, sideBar)
      : sideBar,
    _rowClassRules = Object.assign({}, defaultRowClassRules, rowClassRules),
    // _onCellClicked = onCellClicked,
    _suppressDragLeaveHidesColumn = suppressDragLeaveHidesColumns,
    _statusBar = !statusBar
      ? defaultStatusBar
      : typeof statusBar === 'object'
      ? Object.assign({}, defaultStatusBar, statusBar)
      : statusBar,
    _handleCellClick = evt => {
      const { colDef } = evt;
      if (!colDef.checkboxSelection && !colDef.editable) {
        // ignore the click event if there is a checkbox in this cell
        return handleCellClick(evt);
        // return handleCellClick(evt, history);
      }
    },
    _handleCreateClick = handleCreateClick,
    _showCreateButton = showCreateButton,
    _onSave = onSave,
    _redirectOnClick = redirectOnClick,
    _editOnClick = editOnClick,
    _extraGridProps = extraGridProps;

  const [_gridOptions, setGridOptions] = useState(Object.assign({}, defaultOpts, gridOptions));
  const [gridState, setGridState] = useState({
    firstRow: 0,
    lastRow: 100,
    batchSize: 100,
  });
  const _allowServerExport = useDatasource && allowServerExport !== false;

  const defaultFilterParams = {
    clearButton: true,
    debounceMs: 1000,
  };

  /**
   * OTHER USEFUL PROPS
   *
   * -- used for detail or sub grids
   * - masterDetail
   * - detailRowHeight
   * - detailCellRenderer
   * - frameworkComponents
   * - detailCellRendererParams
   *
   * -- other
   * - groupDefaultExpanded
   *
   */
  const _columnDefs = columnDefs.map(cd => {
    // replace any cell renderers so the data is shown correctly
    if (typeof cd.cellRenderer === 'string' && cellRenderers[cd.cellRenderer]) {
      cd.cellRenderer = cellRenderers[cd.cellRenderer];
    }

    cd.filterParams = Object.assign({}, defaultFilterParams, cd.filterParams);
    return cd;
  });
  let overlayVisible = false;
  let initialLoadDone = false;
  const [rowData, setRowData] = useState(useDatasource ? [] : null);
  const [gridApi, setGridApi] = useState(null);
  // const [gridColumnApi, setGridColumnApi] = useState(null);
  const [editingCell, setEditingCell] = useState({
    row: null,
    field: null,
    value: null,
  }); // current cell being edited
  const [shouldSave, setShouldSave] = useState(false);
  const [modifiedRows, setModifiedRows] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(null);
  const [totalRecords, setTotalRecords] = useState(null); // used when lazy loading and exporting the grid
  const isRestoringColumnStateRef = useRef(false);

  const getGridStorageKey = () => (gridName ? `grid:${gridName}` : window.location.href);

  const saveColumnState = columnApi => {
    if (!columnApi || isRestoringColumnStateRef.current) return;

    const gridKey = getGridStorageKey();
    const existing = JSON.parse(localStorage.getItem(AG_GRID_COLUMN_STATE_STORAGE_KEY) || '{}');
    existing[gridKey] = columnApi.getColumnState();
    localStorage.setItem(AG_GRID_COLUMN_STATE_STORAGE_KEY, JSON.stringify(existing));
  };

  const restoreColumnState = columnApi => {
    if (!columnApi) return;

    const gridKey = getGridStorageKey();
    const existing = JSON.parse(localStorage.getItem(AG_GRID_COLUMN_STATE_STORAGE_KEY) || '{}');
    // Only fall back to URL-keyed state for grids without a gridName (legacy single-grid pages)
    const savedState = gridName ? existing[gridKey] : existing[gridKey] || existing[window.location.href];

    if (savedState) {
      isRestoringColumnStateRef.current = true;
      columnApi.setColumnState(savedState);
      isRestoringColumnStateRef.current = false;
      return;
    }

    restoreLegacyPinsAndSizes(columnApi);
  };

  const restoreLegacyPinsAndSizes = columnApi => {
    const existingPins = JSON.parse(localStorage.getItem(AG_GRID_COLUMN_SIZE_AND_PIN_STORAGE_KEY));
    const legacyGridKey = window.location.href;

    if (!existingPins?.[legacyGridKey]) return;

    const gridPins = existingPins[legacyGridKey];

    Object.keys(gridPins).forEach(colId => {
      const { actualWidth, pinned } = gridPins[colId];

      if (actualWidth) {
        columnApi.setColumnWidth(colId, actualWidth);
      }

      if (pinned !== undefined) {
        columnApi.setColumnPinned(colId, pinned);
      }
    });
  };
  const [isExporting, setIsExporting] = useState(false);

  // update data when it becomes available if it is being passed in by the parent
  useEffect(() => {
    !useDatasource && setRowData(gridData);
    // if (gridData) {
    //   return setRowData(gridData);
    // }
  });

  useEffect(() => {
    if (!useDatasource && !rowData && !overlayVisible) {
      _gridOptions && _gridOptions.api && _gridOptions.api.showLoadingOverlay();
    } else if (!useDatasource && rowData && !rowData.length) {
      _gridOptions && _gridOptions.api && _gridOptions.api.showNoRowsOverlay();
    } else {
      _gridOptions && _gridOptions.api && _gridOptions.api.hideOverlay();
      _gridOptions && _gridOptions.api && _gridOptions.api.hideOverlay();
    }
  }, [rowData]);

  useEffect(() => {
    if (shouldSave && editingCell.row === null && editingCell.field === null) {
      setShouldSave(false);
      _handleSave();
    }
  }, [shouldSave, editingCell]);

  const getFilterParameter = (field, component) => {
    const columnDef = _columnDefs.find(cd => cd.field === field);

    let {
      filterType,
      type: comparison,
      // values
      filter: filterValue,
      filterTo,
      dateFrom,
      dateTo,
    } = component;

    let params = {
      base: null,
      ext: null,
      strReturn: '',
      strValues: '',
    };

    const debug = field === 'orderLineStatusLookupCode' || field === 'pastDue';
    // if (debug) {
    //   console.log('component', filterValue);
    // }
    const returnType = columnDef.boolean ? 'equals' : 'setequals';
    // console.log(returnType);

    switch (filterType) {
      case 'number':
        params.base = filterValue;
        params.ext = filterTo || '';
        params.strReturn = `${field}|${params.base}^${params.ext}|${comparison}`;
        break;
      case 'date':
        params.base = dateFrom;
        params.ext = dateTo || '';
        params.strReturn = `${field}|${params.base}^${params.ext}|${comparison}`;
        break;
      case 'text':
        params.base = filterValue;
        params.ext = '';
        params.strReturn = `${field}|${params.base}^${params.ext}|${comparison}`;
        break;
      case 'set':
        //added the boolean check to handle true/false columns
        if (columnDef.boolean) {
          params.base = component.values.length > 0 ? '' : '999,';
          params.ext = filterTo || '';
          component.values.forEach(function(objFilter, index) {
            params.base = !!columnDef.filterParams.filterLookup
              ? columnDef.filterParams.filterLookup[objFilter]
              : objFilter;
          });
          params.strReturn = `${field}|${params.base}^${params.ext}|${returnType}`;
        } else {
          params.base = component.values.length > 0 ? '' : '999,';

          comparison = returnType;
          params.ext = '';

          component.values.forEach(function(objFilter, index) {
            params.base +=
              (!!columnDef.filterParams.filterLookup ? columnDef.filterParams.filterLookup[objFilter] : objFilter) +
              ',';
          });
          params.strReturn += `${field}|${params.base}^${params.ext}|${comparison}`;
          // debug &&
          //   console.log({
          //     params,
          //   });
        }
        break;
      default:
        console.log('hit a default switch case when filtering... consider adding logic');
        break;
    }

    return params.strReturn;
  };

  const getComponentInstance = (key, cb) => {
    if (!_gridOptions || !_gridOptions.api) return;

    const statusBarComponent = _gridOptions.api.getStatusPanel(key);

    if (!statusBarComponent) return;

    let componentInstance = statusBarComponent;
    if (statusBarComponent.getFrameworkComponentInstance) {
      componentInstance = statusBarComponent.getFrameworkComponentInstance();
    }

    if (!statusBarComponent) return;

    !!cb && cb(componentInstance);
  };

  const getFilterParameters = (field, filter) => {
    let filterParamString = '';

    const { condition1, condition2, operator } = filter;

    // check if the filter has 2 components or not
    if (condition1 && condition2) {
      // filter has component1 and component2
      filterParamString = `${operator}!${getFilterParameter(field, condition1)}!${getFilterParameter(
        field,
        condition2,
      )}`;
    } else {
      // filter only has one component
      filterParamString = getFilterParameter(field, filter);
    }

    return filterParamString;
  };

  const getSortModelStr = sortModel => {
    return !!sortModel.length ? sortModel.map(s => `${s.colId}|${s.sort}`).join(';') : '';
  };

  const getFilterModelStr = filterModel => {
    //console.log(filterModel);
    return !!Object.keys(filterModel).length
      ? Object.keys(filterModel)
          .map(key => getFilterParameters(key, filterModel[key]))
          .join('~')
      : '';
  };

  /**
   * @func _exportLazyLoadedGrid
   * @desc gets the excel file for any orders grid that is using a sproc to fill it
   */
  const _exportLazyLoadedGrid = async () => {
    if (!gridApi || !gridApi.filterManager || !gridApi.sortController) {
      return console.log('grid api, filterManager, or sortController does not exist...');
    }
    try {
      setIsExporting(true);
      const filterModel = gridApi.filterManager.getFilterModel();
      const sortModel = gridApi.sortController.getSortModel();
      const filterModelStr = getFilterModelStr(filterModel);
      const sortModelStr = getSortModelStr(sortModel);
      const columnsStr = (columnDefs || [])
        .filter(col => col.field && !col.hide)
        .map(col => `${col.field}:${col.headerName || col.field}`)
        .join(',');
      const queryStr = `_sortModel=${sortModelStr}&_filterModel=${filterModelStr}&gridName=${gridName}&_totalRecords=${totalRecords}&_columns=${encodeURIComponent(columnsStr)}`;
      await getGridExcelExport(queryStr);
      console.log('done downloading excel');
    } catch (error) {
      console.log(error);
    } finally {
      setIsExporting(false);
    }
  };

  /**
   * @func _handleLocalGridExport
   * @desc gets the excel file for the data that is served up by the grid
   */
  const _handleLocalGridExport = async () => {
    if (!gridApi || !gridApi.filterManager || !gridApi.sortController) {
      return console.log('grid api, filterManager, or sortController does not exist...');
    }

    try {
      setIsExporting(true);
      gridApi.exportDataAsExcel(exportParams);
    } catch (error) {
      console.log(error);
    } finally {
      setIsExporting(false);
    }
  };

  /**
   * @func _onGridReady
   * @desc a callback to run when the grid is rendered and ready for data
   * @param params grid parameters including its own API
   */
  const _onGridReady = async params => {
    await setGridApi(params.api);

    if (onGridReady) {
      onGridReady(_gridOptions);
    }

    // check for persistent filters
    const persistentFilters = JSON.parse(localStorage.getItem(FILTERS_STORAGE_KEY));
    const persistentSort = JSON.parse(localStorage.getItem(SORT_STORAGE_KEY));

    if (persistentSort && persistentSort.url === window.location.href) {
      params.api.setSortModel(persistentSort.sortModel);
    }

    if (
      persistentFilters &&
      persistentFilters.href === window.location.href &&
      _gridOptions.api
      // && _gridOptions.rowModelType !== "infinite"
    ) {
      // set hidden columns
      // console.log(persistentFilters, _gridOptions, persistentFilters.href === window.location.href)
      persistentFilters.filters.forEach(filter => {
        /**
         * Set filter model
         * 1. get filter instance
         * 2. set the model
         */

        const { name, model } = filter;

        const filterComp = _gridOptions.api.getFilterInstance(name);
        if (filterComp) {
          filterComp.setModel(model);
          filterComp.onFilterChanged();
        }
      });
    }

    restoreColumnState(params.columnApi);

    defaultFilters.forEach(filter => {
      /**
       * Set filter model
       * 1. get filter instance
       * 2. set the model
       */

      const { name, model } = filter;

      const filterComp = _gridOptions.api.getFilterInstance(name);
      filterComp.setModel(model);
      filterComp.onFilterChanged();
    });
    // {name: "orderLineStatusLookupCode", model: {filterType: "text", type: "contains", filter: "com"}}

    const updateData = data => {
      const dsrc = {
        rowCount: null,
        getRows: params => {
          // invoke your server with request params supplied by grid
          // var response = server.getResponse(params.request);

          // if (response.success) {
          //   // call the success callback
          //   params.successCallback(response.rows, response.lastRow);
          // } else {
          //   // inform the grid the request failed
          //   params.failCallback();
          // }

          const { startRow, endRow, successCallback, failCallback, filterModel, sortModel } = params;

          const getData = async () => {
            // set the loading indicator
            getComponentInstance('statusPanelLoadingKey', comp => {
              comp.setIsLoading(true);
            });

            // if the initial load is not done, show the overlay loading
            if (!initialLoadDone) {
              _gridOptions.api.showLoadingOverlay();
              initialLoadDone = true;
            }

            const token = localStorage.getItem('token');
            let headers = {};
            if (token) {
              headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              };
            }

            const sortModelStr = getSortModelStr(sortModel);
            const filterModelStr = getFilterModelStr(filterModel);

            try {
              // console.log(filterModelStr, filterModel);
              const response = await fetch(
                `${DEFAULT_API_CONFIG.url}${datasourceUrl}?_startRow=${startRow}&_endRow=${endRow}&_sortModel=${sortModelStr}&_filterModel=${filterModelStr}&gridName=${gridName}`,
                // `http://localhost:63138/api/v1/orders?_startRow=${startRow}&_endRow=${endRow}&_sortModel=${sortModelStr}&_filterModel=${filterModelStr}`,
                {
                  method: 'GET',
                  headers,
                },
              );

              // hide the loading overlay
              _gridOptions.api && _gridOptions.api.hideOverlay();

              if (response.status === 200) {
                const json = await response.json();
                const newRows = json.results;

                successCallback(newRows, json.totalRecords < endRow ? json.totalRecords : endRow + 20);
                setTotalRecords(json.totalRecords);

                // update the status bar
                getComponentInstance('statusToolbarKey', comp => {
                  comp.updateRecords(json.totalRecords, json.totalRecords < endRow ? json.totalRecords : endRow);
                });

                // determine if the no rows overlay is needed
                if (json.totalRecords === 0) {
                  // show the no rows overlay
                  _gridOptions.api.showNoRowsOverlay();
                } else {
                  // hide the no rows overlay
                  _gridOptions.api.hideNoRowsOverlay();
                }
              } else {
                throw new Error('somethin happened');
              }
            } catch (error) {
              failCallback();

              // hide the overlay
              _gridOptions.api && _gridOptions.api.hideOverlay();
            }

            // set the loading indicator
            getComponentInstance('statusPanelLoadingKey', comp => {
              comp.setIsLoading(false);
            });

            // successCallback(, lastRow);
            // successCallback(rowsOnThisPage, lastRow);
          };
          getData();
        },
      };
      params.api.setDatasource(dsrc);
    };

    if (useDatasource) {
      _gridOptions.api && updateData();
    }
  };

  /**
   * @func _onColumnPinned
   * @param {*} evt
   */
  const _onColumnPinned = evt => {
    if (!evt.column) return;
    saveColumnState(evt.columnApi);
  };

  /**
   * @func _onColumnResized
   * @param {*} evt
   */
  const _onColumnResized = evt => {
    if (!evt.column || !evt.finished) return;
    saveColumnState(evt.columnApi);
  };

  /**
   * @func _onColumnMoved
   * @param {*} evt
   */
  const _onColumnMoved = evt => {
    saveColumnState(evt.columnApi);
  };

  /**
   * @func _onColumnVisible
   * @param {*} evt
   */
  const _onColumnVisible = evt => {
    saveColumnState(evt.columnApi);
  };

  /**
   * @func _onFilterChanged
   * @desc updates persistent filters when a filter is changed
   */
  const _onFilterChanged = evt => {
    const allFilters = evt.api.filterManager.allFilters;

    if (!_gridOptions.api) {
      return;
    }

    const filterStorageObj = {
      href: window.location.href,
      filters: [],
    };

    Object.keys(allFilters).forEach(filterKey => {
      const filterComp = _gridOptions.api.getFilterInstance(filterKey);
      const filterModel = filterComp.getModelFromUi();
      // console.log(filterModel);

      filterStorageObj.filters.push({
        name: filterKey,
        model: filterModel,
      });
    });

    localStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(filterStorageObj));
  };

  /**
   * @func _handleCellEditingStarted
   * @desc updates state with the initial state of a cell (for comparing against later)
   * @param evt event object when editing has started
   */
  const _handleCellEditingStarted = evt => {
    setEditingCell({
      row: evt.rowIndex,
      field: evt.colDef.field,
      value: evt.value,
    });
  };

  /**
   * @func _handlCellEditingStopped
   * @desc compares current state to previous state and determines if the row has been edited
   *        (adds a red background to edited rows through RowStyle)
   * @param evt event object when editing has stopped
   */
  const _handleCellEditingStopped = evt => {
    const { value } = evt;
    const { field, dataType } = evt.colDef;

    if (value != editingCell.value) {
      !modifiedRows.includes(evt.rowIndex) && setModifiedRows(modifiedRows.concat(evt.rowIndex));
      const row = gridApi.getRowNode(evt.rowIndex);
      evt.data.edited = true;

      if (value === '' && !editingCell.value) {
        evt.data.edited = false;
      }

      // check data type
      if (dataType) {
        switch (dataType) {
          case 'number':
            evt.value = isNaN(value) && value.length ? editingCell.value : parseFloat(value) || 0;
            evt.data[field] = isNaN(value) && value.length ? editingCell.value : parseFloat(value) || 0;
            break;
          default:
            break;
        }
      }
      row.setData(evt.data);
      setEditingCell({
        row: null,
        field: null,
        value: null,
      });
      // debugger;
    }
  };

  /**
   * @func _handleSave
   * @desc saves any edited data in the grid
   */
  const _handleSave = async () => {
    // reset error and success messages
    setSubmitError(null);
    setSubmitSuccess(null);

    // get all row data from the grid
    let rowData = [];
    gridApi.forEachNode(node => (rowData = rowData.concat(node.data)));

    let modifedRowsData = modifiedRows.map(rowIdx => gridApi.getRowNode(rowIdx).data);

    try {
      setIsSubmitting(true);
      const res = await onSave(rowData, modifedRowsData);
      // const res = await onSave(modifedRowsData);

      // reset colors on editted cells when the request is successful
      modifiedRows.forEach(rowIndex => {
        const node = gridApi.getRowNode(rowIndex);
        node.data.edited = false;
        node.setData(node.data);
      });
      setModifiedRows([]);
      setSubmitSuccess('Update Successful!');
      setTimeout(() => setSubmitSuccess(null), 10000);
    } catch (error) {
      setSubmitError(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  /**
   * @func _handleSaveButtonClick
   * @desc
   */
  const _handleSaveButtonClick = async () => {
    //if there is a cell being edited, stop the editing first
    if (editingCell.row !== null && editingCell.field !== null) {
      gridApi.stopEditing();
      setTimeout(() => setShouldSave(true), 250);
    } else {
      setShouldSave(true);
    }
  };

  /**
   * @func _openBulkEditDialog
   * @desc gathers selected data and sends it to the parent to show in the Dialog
   */
  const _openBulkEditDialog = () => {
    if (!gridApi) return;

    const selectedRowData = gridApi.getSelectedRows();
    openBulkEditDialog(selectedRowData);
  };

  /**
   * @func _openBulkReleaseDialog
   * @desc gathers selected data and sends it to the parent to show in the Dialog
   */
  const _openBulkReleaseDialog = () => {
    if (!gridApi) return;

    const selectedRowData = gridApi.getSelectedRows();
    openBulkReleaseDialog(selectedRowData);
  };

  /**
   * @func _clearAllFilters
   * @desc gets all active filters and clears them
   */
  const _clearAllFilters = () => {
    gridApi.setFilterModel(null);
    gridApi.setSortModel(null);
  };

  /**
   * @func _clearAllPinsAndResizes
   * @desc gets all active filters and clears them
   */
  const _clearAllPinsAndResizes = () => {
    const gridKey = getGridStorageKey();
    const legacyGridKey = window.location.href;

    const existingColumnState = JSON.parse(localStorage.getItem(AG_GRID_COLUMN_STATE_STORAGE_KEY) || '{}');
    delete existingColumnState[gridKey];
    delete existingColumnState[legacyGridKey];
    localStorage.setItem(AG_GRID_COLUMN_STATE_STORAGE_KEY, JSON.stringify(existingColumnState));

    const existingPins = JSON.parse(localStorage.getItem(AG_GRID_COLUMN_SIZE_AND_PIN_STORAGE_KEY) || '{}');
    delete existingPins[legacyGridKey];
    localStorage.setItem(AG_GRID_COLUMN_SIZE_AND_PIN_STORAGE_KEY, JSON.stringify(existingPins));

    _gridOptions.columnApi.resetColumnState();
  };

  /**
   * @func _onSortChanged
   * @desc gets the sort model and stores in in localStorage
   */
  const _onSortChanged = ({ api }) => {
    const sortModel = api.getSortModel();
    const url = window.location.href;
    const storageObject = {
      sortModel: sortModel,
      url: url,
    };
    localStorage.setItem(SORT_STORAGE_KEY, JSON.stringify(storageObject));
  };

  /**
   * @func _onDataFirstRendered
   * @desc the first time the data gets rendered, apply filter model, apply sort mode
   * this is only for the grids that do not use a datasource
   */
  const _onFirstDataRendered = params => {
    let filterModel = JSON.parse(localStorage.getItem(FILTERS_STORAGE_KEY));
    let sortModel = localStorage.getItem(SORT_STORAGE_KEY);
    const gridKey = window.location.href;

    if (gridKey == filterModel?.href && !useDatasource) {
      let allFilters = {};
      filterModel.filters.forEach(fm => {
        allFilters[fm.name] = fm.model;
      });

      if (params.api && !useDatasource) {
        params.api.setFilterModel(allFilters);
      }
    }

    if (sortModel && gridKey == sortModel.url && !useDatasource) {
      if (params.api && !useDatasource) {
        params.api.setSortModel(sortModel.sort);
      }
    }
  };

  return (
    <div className={classnames('flex-1', 'col-center-center', 'align-stretch', classes.mainContainer)}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
        className={classnames('row-between-center')}
      >
        <div className={classnames('row-start-center')}>
          {tableHeader && <span style={{ fontWeight: 'bold', fontSize: 32, marginRight: 20 }}>{tableHeader}</span>}
          {headerContent}
          {editOnClick && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Button
                disabled={isSubmitting}
                style={{ backgroundColor: '#315382', color: '#fff' }}
                variant="contained"
                onClick={_handleSaveButtonClick}
              >
                {isSubmitting ? <CircularProgress style={{ fill: '#fff', color: '#fff' }} size={25} /> : 'Save All'}
              </Button>
              <span style={{ marginLeft: 15 }}>
                {submitError}
                {submitSuccess}
              </span>
            </div>
          )}
          {_showCreateButton && _handleCreateClick && (
            <Button
              style={{
                backgroundColor: '#315382',
                color: '#fff',
                marginRight: 15,
              }}
              variant="contained"
              onClick={_handleCreateClick}
            >
              + Create New
            </Button>
          )}
          {/* <div style={{ marginLeft: 10 }}>Modified Rows: { modifiedRows.join(',') }</div> */}

          {openBulkEditDialog && (
            <Button
              style={{
                backgroundColor: rowData ? '#315382' : 'none',
                color: '#fff',
                marginRight: 15,
              }}
              variant="contained"
              onClick={_openBulkEditDialog}
              disabled={!rowData}
            >
              Bulk Edit
            </Button>
          )}
          {openBulkReleaseDialog && (
            <Button
              style={{
                backgroundColor: rowData ? '#315382' : 'none',
                color: '#fff',
                marginRight: 15,
              }}
              variant="contained"
              onClick={_openBulkReleaseDialog}
              disabled={!rowData}
            >
              Bulk Release
            </Button>
          )}

          {_allowServerExport && (
            <Button
              style={{
                backgroundColor: rowData ? '#315382' : 'none',
                color: '#fff',
                marginRight: 15,
                justifySelf: 'end',
                width: 180,
              }}
              variant="contained"
              onClick={_exportLazyLoadedGrid}
              disabled={!rowData || isExporting}
            >
              {!isExporting && <span>Export All Data</span>}
              {isExporting && <CircularProgress color={'#FFF'} size={20} />}
            </Button>
          )}
        </div>

        {/* buttons on the right side */}
        <div>
          {showLocalGridExport && (
            <Button
              style={{
                backgroundColor: '#315382',
                color: '#fff',
                justifySelf: 'end',
                marginRight: 15,
              }}
              variant="contained"
              onClick={_handleLocalGridExport}
              disabled={!rowData || isExporting}
            >
              Export to Excel
            </Button>
          )}

          <Button
            style={{
              backgroundColor: '#315382',
              color: '#fff',
              justifySelf: 'end',
              marginRight: 15,
            }}
            variant="contained"
            onClick={_clearAllFilters}
            disabled={!rowData || isExporting}
          >
            Clear all filters
          </Button>

          <Button
            style={{
              backgroundColor: '#315382',
              color: '#fff',
              justifySelf: 'end',
            }}
            variant="contained"
            onClick={_clearAllPinsAndResizes}
            disabled={!rowData || isExporting}
          >
            Clear pins and resizes
          </Button>
        </div>
      </div>

      <div style={{ flex: 1, alignSelf: 'stretch', boxSizing: 'border-box', marginTop: 10 }}>
        <div
          id="myGrid"
          style={{
            height: '100%',
            width: '100%',
            textAlign: 'left',
          }}
          className={classnames(
            _gridTheme,
            _editOnClick && 'ag-grid-cell-editable',
            _redirectOnClick && 'ag-grid-cell-clickable',
          )}
        >
          <AgGridReact
            //configurations
            columnDefs={_columnDefs}
            gridOptions={_gridOptions}
            defaultColDef={_defaultColDef}
            floatingFilter={_floatingFilter}
            sideBar={_sideBar}
            statusBar={_statusBar}
            rowClassRules={_rowClassRules}
            suppressDragLeaveHidesColumns={_suppressDragLeaveHidesColumn}
            // grid event listeners
            onFilterChanged={_onFilterChanged}
            onFirstDataRendered={_onFirstDataRendered}
            onSortChanged={_onSortChanged}
            onColumnPinned={_onColumnPinned}
            onColumnResized={_onColumnResized}
            onColumnMoved={_onColumnMoved}
            onColumnVisible={_onColumnVisible}
            onGridReady={_onGridReady}
            onCellEditingStarted={editOnClick && _handleCellEditingStarted}
            onCellEditingStopped={editOnClick && _handleCellEditingStopped}
            onCellClicked={redirectOnClick && _handleCellClick}
            // row data
            rowData={rowData}
            // extra stuff
            {..._extraGridProps}
          />
        </div>
        {/* )} */}
      </div>
    </div>
  );
});

AgGrid.propTypes = {
  // REQUIRED
  gridData: PropTypes.any, // null if data is still loading, array if data is available
  columnDefs: PropTypes.arrayOf(PropTypes.object).isRequired,

  // NOT REQUIRED
  gridOptions: PropTypes.object,
  gridTheme: PropTypes.string,
  handleCellClick: PropTypes.func,
  handleCreateClick: PropTypes.func,
  showCreateButton: PropTypes.bool,
  onSave: PropTypes.func,
  defaultColDef: PropTypes.object,
  sideBar: PropTypes.any,
  statusBar: PropTypes.any,
  floatingFilter: PropTypes.any,
  rowClassRules: PropTypes.object,
  redirectOnClick: PropTypes.bool,
  editOnClick: PropTypes.bool,
  extraGridProps: PropTypes.object,
  openBulkEditDialog: PropTypes.func,
  openBulkReleaseDialog: PropTypes.func,
  tableHeader: PropTypes.string,
  onGridReady: PropTypes.func,
  useDatasource: PropTypes.bool,
  datasourceUrl: PropTypes.string,
  gridName: PropTypes.string,
  defaultFilters: PropTypes.arrayOf(PropTypes.object),
  allowServerExport: PropTypes.bool,
  showLocalGridExport: PropTypes.bool,
  headerContent: PropTypes.any,
  exportParams: PropTypes.any,
};

AgGrid.defaultProps = {
  gridOptions: {},
  statusBar: {},
  gridTheme: 'ag-theme-material',
  handleCellClick: evt => (window.location = `${window.location.href}/${evt.data.id}`),
  // handleCellClick: (evt, history) =>
  //   history.push(`${history.location.pathname}/${evt.data.id}`),
  handleCreateClick: evt => (window.location = `${window.location.href}/create`),
  showCreateButton: false,
  floatingFilter: true,
  redirectOnClick: true,
  editOnClick: false,
  extraGridProps: {},
  allowBulkEditMode: false,
  tableHeader: '',
  useDatasource: false,
  defaultFilters: [],
  allowServerExport: true,
  showLocalGridExport: false,
};

// export default withRouter(withStyles(styles)(CustomAgGrid));
